import axios from "axios";
import {
  LOGOUT_USER,
  SET_ADMIN_USER_STATE,
} from "../constants/action-type";

export const setAdminUserStateAction = (userStatePayload) => ({
    type: SET_ADMIN_USER_STATE,
    payload: userStatePayload,
  });

export const logoutUser = () => {
  localStorage.removeItem("token");
  return {
    type: LOGOUT_USER,
  };
};

